import * as workspaces from '../../config/WorkspaceConstants'

export function getWorkspaceToSendForServiceNow(workspace) {
  if (workspace) {
    if (workspace === workspaces.automation_ops) {
      return 'RPA';
    } else {
      return "TAC";
    }
  }
  else {
    return "";
  }
}

export function getClientToSendForServiceNow(workspace, client) {
  if (workspace) {
    if (workspace !== workspaces.sap_ops) {
      return client;
    } else {
      return client;
    }
  }
  else {
    return "";
  }
}
